const menuElement = document.querySelectorAll('.js-sidebar-toggle');
const backDrop = document.querySelector('.menuBackdrop');
const openNavigation = document.querySelector('.js-open-navigation');
const wholeMenu = document.querySelector('.js-open-navigation').children[0];
const id = document.querySelector('.after-sticky[data-id]').dataset.id;

function showTheCurrentPage() {
  if(!id || id != 'None')  {
    const item = wholeMenu.querySelector(`[data-id='${id}']`);
    if(!item) {
      return
    }
    item.style.color = "#AF956E";
    applyIsOpen(item)
  }
}

function applyIsOpen(closestItem) {
  const closestUl = closestItem.parentElement.closest(`ul`)

  if (!closestUl || closestUl === closestItem || closestUl.classList.contains('navigation--container__main')) {
    return
  }

    closestUl.classList.toggle('_is-open');
  

  applyIsOpen(closestUl)
}

function swipeGesture() {
  // Get a reference to an element.
  var square = document.querySelector('.square');

  Hammer(openNavigation).on('swipeleft', function() {
      openNavigation.classList.remove('_is-open');
      backDrop?.classList?.remove('_show');
      document.querySelector('.header-mobile').classList.remove('hidden');
      document.querySelector('.header-top-nav').classList.remove('hidden');
  });
}


swipeGesture();

menuElement.forEach(function(element) {

  if(menuElement) {
    element.addEventListener('click', function(e) {
      backDrop.classList.toggle('_show');
      document.querySelector('.header-mobile').classList.toggle('hidden');
      document.querySelector('.header-top-nav').classList.toggle('hidden');
          
    });
  }

  function iosViewportHeight() {
    let vh = window.innerHeight * 0.01;

    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  iosViewportHeight();

  window.addEventListener('resize', () => {
    iosViewportHeight();
  });

  if (element && openNavigation) {
    const links = openNavigation.querySelectorAll('.link');
    let listeners = [];

    function openNav(event) {
      event.preventDefault();
      openNavigation.classList.toggle('_is-open');
      document.querySelector('body').classList.toggle('no-scroll');
      showTheCurrentPage();
    }

    function openSubNav(event) {
      if (event.currentTarget.getAttribute('href') === '#') {
        event.preventDefault();

        if (event.currentTarget.parentElement.classList.contains('go-back')) {
          event.currentTarget.parentNode.parentNode.classList.remove('_is-open');
        }else if (event.currentTarget.parentElement.classList.contains('_has-sub') && event.currentTarget.nextElementSibling.classList.contains('navigation--container')) {
          event.currentTarget.nextElementSibling.classList.add('_is-open');
        }
      }
    }

    function removeOpenState() {
      document.querySelectorAll('._is-open').forEach((event) => {
        event.classList.toggle('_is-open');
      });
    }

    function removeListeners(listeners) {
      for (let listener in listeners) {
        listener.removeEventListener('click', openNav);
        listener.removeEventListener('click', openSubNav);
      }
      return []
    }

    function initClicks() {
      listeners = removeListeners();

      listeners.push(element.addEventListener('click', openNav));

      links.forEach(function(link) {
        listeners.push(link.addEventListener('click', openSubNav));
      });
    }

    if (document.body.clientWidth < 1200) {
      initClicks();
    }

    window.addEventListener('resize', (event) => {
      if (document.body.clientWidth >= 1200) {
        listeners = removeListeners();
        removeOpenState();
      } else {
        initClicks();
      }
    });

    $(document).on('mouseenter', '.categorie-list [data-toggle="tab"]', function () {
      $(this).tab('show');
    });
  }
});